<ng-template #tpl>
	<ng-container *transloco="let translate">
		<div class="text-center">
			<div class="my-1 w-full">
				<img class="h-15" src="assets/images/core/robot-error.svg" />
				<div class="mt-0.5 text-xs text-warn">
					@if (!!$quotaNodes()) {
						<span>
							{{ $quotaNodes()?.used || 0 }}/{{ $quotaNodes()?.total || 0 }}
						</span>
					}

					@if (!$quotaNodes()) {
						<span> &nbsp; </span>
					}
				</div>
			</div>

			<p class="text-icon font-bold text-center">
				{{ translate('errorModals.chat_ai_conversations_quota.title') }}
			</p>

			<p
				class="my-1.5"
				[innerHTML]="translate('errorModals.chat_ai_conversations_quota.description')"
			></p>

			<button
				class="py-0.75 px-1.5 w-full fc-white bg-primary font-bold box-border rounded-0.5"
				(click)="confirm()"
			>
				{{ translate('errorModals.quota_common.check') }}
			</button>

			<button
				class="py-0.75 px-1.5 w-full fc-400 font-bold box-border"
				(click)="cancel()"
			>
				{{ translate('general.close') }}
			</button>
		</div>
	</ng-container>
</ng-template>
